// Payments & Accounting — company-wide financial integrations.
// Renders Stripe onboarding + the QuickBooks Online card (with preflight/wizard).
// POS Terminal lives on its own tab because it's location-scoped.
import React from 'react';
import PaymentSetup from '../PaymentSetup';
import QuickBooksSetup from '../QuickBooksSetup';

const PaymentsTab = ({
  installer,
  stripeCapabilities,
  paymentLoading,
  onSetupComplete,
  onManagePayment,
  qbo,
  qboLoading,
  onEnableQbo,
  onQboStatusChange,
  onOpenQboSetupWizard,
  onQboReconnect,
  onQboResetConnection
}) => {
  const qboConnected = qbo && qbo.connected && !qbo.token_expired;
  const qboExpired = qbo && qbo.token_expired;
  const qboOnline = installer?.qb_mode === 'online';

  return (
    <>
      {/* Payment Account (Stripe) */}
      <div className="card mb-4">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="mb-0">Payment Account</h4>
          {installer?.stripe_account_id && installer?.onboarding_complete && (
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={onManagePayment}
              disabled={paymentLoading}
            >
              {paymentLoading ? 'Loading...' : 'Manage Account'}
            </button>
          )}
        </div>
        <div className="card-body">
          <PaymentSetup
            installer={installer}
            stripeCapabilities={stripeCapabilities}
            onSetupComplete={onSetupComplete}
            hideManageButton={true}
          />
        </div>
      </div>

      {/* QuickBooks — card body branches on qb_mode. */}
      <div className="card mb-4">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="mb-0">
              <i className="fa-sharp fa-regular fa-book mr-2"></i>
              QuickBooks
            </h4>
            {qboOnline && (qboConnected || qboExpired) && (
              <div>
                <button
                  className="btn btn-outline-warning btn-sm mr-2"
                  onClick={onQboReconnect}
                  disabled={qboLoading}
                >
                  {qboLoading === 'reconnect' ? 'Reconnecting...' : 'Re-connect'}
                </button>
                <button
                  className="btn btn-outline-danger btn-sm"
                  onClick={onQboResetConnection}
                  disabled={qboLoading}
                >
                  {qboLoading === 'reset' ? 'Resetting...' : 'Reset Connection'}
                </button>
              </div>
            )}
          </div>
          <div className="card-body">
            {qboOnline ? (
              <QuickBooksSetup
                installer={installer}
                qbo={qbo}
                onStatusChange={onQboStatusChange}
                onSetupClick={onOpenQboSetupWizard}
              />
            ) : (
              <div>
                <p className="text-muted mb-3">
                  Turn on QuickBooks Online to automatically sync invoices and payments to your Intuit account.
                </p>
                <button
                  className="btn btn-primary"
                  onClick={onEnableQbo}
                  disabled={qboLoading === 'enable'}
                >
                  {qboLoading === 'enable' ? (
                    <>
                      <span className="spinner-border spinner-border-sm mr-2" role="status"></span>
                      Enabling...
                    </>
                  ) : (
                    <>
                      <i className="fa-sharp fa-regular fa-bolt mr-1"></i>
                      Enable QuickBooks Online
                    </>
                  )}
                </button>
              </div>
            )}
          </div>
        </div>
    </>
  );
};

export default PaymentsTab;
